import SettingsBox from 'src/Elements/Data/SettingsBox'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import BooleanToggle from 'src/Libs/inputs/formik/BooleanToggle'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'

interface Props {
  title: string
  trueLabel?: string
  falseLabel?: string
  description?: string
  name: string
  disabled?: boolean
  tooltipText?: string
  depth?: number
  fullWidth?: boolean
}

const SingleToggleSettingBox: React.FC<Props> = ({
  title,
  name,
  disabled = false,
  falseLabel,
  trueLabel,
  tooltipText = '',
  depth = 0,
  fullWidth = false,
  ...rest
}) => {
  const { t } = useCustomTranslation()
  const actionButtons = (
    <OptionalTooltipWrapper titleKey={tooltipText}>
      <BooleanToggle
        name={name}
        trueLabel={trueLabel ?? t('singleToggleSettingBox.controls.on')}
        falseLabel={falseLabel ?? t('singleToggleSettingBox.controls.off')}
        disabled={disabled}
        fullWidth={fullWidth}
      />
    </OptionalTooltipWrapper>
  )
  return <SettingsBox title={title} suffix={actionButtons} {...rest} disabled={disabled} depth={depth} />
}

export default SingleToggleSettingBox
